export default __webpack_public_path__ + "static/media/Photo02.f34e21cb.jpg";